export default [
  {
    $ID: 'PopPupLayot',
    Name: 'PopPup page layout',
    Model:
    {
      '$ID': 'layout1',
      '$Type': 'PopPupLayout'
    }
  },
  {
    $ID: 'ExtendedFullPageLayout',
    Name: 'Extended FullPage Layout',
    Model:
    {
      '$ID': 'layout1',
      '$Type': 'ExtendedFullPageLayout'
    }
  },
  {
    $ID: 'ExtendedLayout',
    Name: 'Extended Layout',
    Model:
    {
      '$ID': 'layout1',
      '$Type': 'ExtendedLayout'
    }
  },
  {
    $ID: 'MainLayout',
    Name: 'Main page layout',
    Model:
    {
      '$ID': 'layout1',
      '$Type': 'MainLayout'
    }
  },
  {
    $ID: 'MenuLayout',
    Name: 'Menu layout',
    Model:
    {
      '$ID': 'menuLayout1',
      '$Type': 'MenuLayout'
    }
  },
  {
    $ID: 'LayoutWithoutToolbar',
    Name: 'Layout Without Toolbar',
    Model:
    {
      '$ID': 'menuLayout1',
      '$Type': 'LayoutWithoutToolbar'
    }
  },

  {
    $ID: 'MenuLayoutWidgets',
    Name: 'Menu Layout Widgets',
    Model:
        {
          '$ID': 'menuLayoutWidgets1',
          '$Type': 'MenuLayoutWidgets'
        }
  },
  {
    $ID: 'HorizontalLayout',
    Name: 'Horizontal page layout',
    Model:
    {
      '$ID': 'layout1',
      '$Type': 'HorizontalLayout'
    }
  },
  {
    $ID: 'FullPageLayout',
    Name: 'Full page layout',
    Model:
    {
      '$ID': 'layout2',
      '$Type': 'FullPageLayout'
    }
  },
  {
    $ID: 'EmptyLayout',
    Name: 'Empty layout',
    Model:
    {
      '$ID': 'empty',
      '$Type': 'EmptyLayout'
    }
  }
]
  